export default {
  GeneralDepartment: 1, // tổng cục
  Department: 2, // cục
  SubDepartment: 3, // chi cục
};
